/**
 * /frontend/src/features/analytics/api/whatIfAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches what-if sections simulation.
 */
export const getWhatIfSections = async (request, token, storeId, addSections, removeSections) => getJson(
  request,
  ANALYTICS_ENDPOINTS.WHATIF_SECTIONS,
  { storeId, addSections, removeSections },
  token,
  'analytics-whatif-sections'
);

/**
 * Fetches what-if staff simulation.
 */
export const getWhatIfStaff = async (request, token, storeId, additionalStaff, reducedStaff) => getJson(
  request,
  ANALYTICS_ENDPOINTS.WHATIF_STAFF,
  { storeId, additionalStaff, reducedStaff },
  token,
  'analytics-whatif-staff'
);

/**
 * Fetches what-if hours simulation.
 */
export const getWhatIfHours = async (request, token, storeId, shiftStartBy, shiftEndBy) => getJson(
  request,
  ANALYTICS_ENDPOINTS.WHATIF_HOURS,
  { storeId, shiftStartBy, shiftEndBy },
  token,
  'analytics-whatif-hours'
);

